import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import logo from '../../assets/mtlawllc-logo-header.png';
import headImg from '../../assets/icon-user.png';

export const Root = styled(Box)({
    display: 'flex',
    '& .appbar': {
        zIndex: '1201',
        '& .logo': {
            width: '187px',
            height: '43px',
            background: `url(${logo}) no-repeat center top/cover`,
        },
        '& .icon': {
            color: '#005E96',
        },
    },
    '& .drawer': {
        width: '240px',
        flexShrink: '0',
        '& .user': {
            margin: '0 20px',
            padding: '16px 0',
            cursor: 'pointer',
            borderBottom: '1px solid #D8D8D8',
            '& .head': {
                width: '60px',
                height: '60px',
                marginBottom: '10px',
                borderRadius: '50%',
                background: `url(${headImg}) no-repeat center top/cover`,
            },
            '& .username': {
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#005E96',
            },
            '& .job': {
                color: '#9B9B9B',
            },
        },
    },
    '& .drawer > div': {
        width: '240px',
    },
    '& > .content': {
        maxWidth: 'calc(100% - 240px)'
    },
    '& .content': {
        minHeight: '100vh',
        flexGrow: '1',
        padding: '10px',
        background: 'linear-gradient(180deg, #D8E8EF 0%, #C7D6E2 100%)',
    },
    '& .toolbar': {
        minHeight: '64px',
    },
    '& .navItem': {
        // color: '#1A9AE7',
    },
    '& .subItem': {
        paddingLeft:'72px',
    },
});